import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LocationProvider } from "./Context/LocationProvider";
import LoginPage from "./Pages/LoginPage";
import Process from "./Pages/Process";
import ChromeBanner from "./Components/browser/browser";
import Unauthorized from "./Pages/unauth";
import ExistingPatientRegistrationForms from "./Pages/Forms/Patient Registration Forms/ExistingPatReg";
import PatientRegistrationForms from "./Pages/Forms/Patient Registration Forms/newPatientReg";
import DailyAppointmentPage from "./Pages/DailyAppointmentPage";
import SurgeryForms from "./Pages/Forms/Surgery Forms/SurgeryForms";
import SurgeryConsent from "./Pages/Forms/Surgery Forms/SurgeryConsent";
import ConsentForm from "./Pages/Forms/Patient Registration Forms/Consent";
import Injection from "./Pages/Forms/Injection Forms/Injection";
import ContextNotFound from "./Pages/ContextNotFound";
import NotFound from "./Pages/notFound"
import Help from "./Pages/Help"
import Admin from "./Pages/Admin"
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ZoomProvider } from "./Context/Zoom";


const App = () => {

  return (
    <LocationProvider>
      <ZoomProvider>
        <Router>
          <ChromeBanner />
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/unauth" element={<Unauthorized />} />
            <Route path="/process" element={<Process />} />
            <Route path="/daily-appointments" element={<DailyAppointmentPage />} />
            <Route path="/help" element={<Help />} />
            <Route path="/injection/:chart/:date/:apptId" element={<Injection/>} />
            <Route path="/surgical-forms/:chart/:date/:apptId" element={<SurgeryForms />} />
            <Route path="/surgical-consent/:chart/:date/:apptId" element={<SurgeryConsent />} />
            <Route path="/context-not-found" element={<ContextNotFound />} />
            <Route path="/existing-patient-registration-form/:chart/:apptId" element={<ExistingPatientRegistrationForms />} />
            <Route path="/patient-registration-form/:chart/:apptId" element={<PatientRegistrationForms />} />
            <Route path="/consent/:chart/:apptId" element={<ConsentForm />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </ZoomProvider>
    </LocationProvider>
  );
};

export default App;
